<template>
  <v-container>
    <v-toolbar flat>
      <v-card-actions>
        <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
          mdi-arrow-left-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar-title style=""><b>Course {{this.$store.state.course.courseTitle}}</b></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-main>
      <v-container fluid>
        <v-layout align-start justify-center>
          <v-flex xs4 class="elevation-1 pa-3 ma-2">
            <v-list style="max-height:500px" class="overflow-y-auto">
              <v-subheader>
                <b>COURSE LESSON LIST</b>
              </v-subheader>
              <draggable 
                v-model="courseLessonList" 
                :options="{group:'lessons'}" 
                style="min-height: 10px"
              >
                <template v-for="item in courseLessonList">
                  <v-list-item :key="item._id">
                    <v-list-item-content>
                      <v-list-item-title 
                        v-html="item.lessonId"
                      ></v-list-item-title>
                      <v-list-item-subtitle 
                        v-html="item.lessonTitle"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </draggable>
            </v-list>
          </v-flex>

          <v-flex xs1 class="px-5 align-items-center">
            <p style="font-size: 13px;color: #000;margin: 10px 0 30px;">
              Move Items
            </p>
            <div
              class="v-icon d-flex notranslate mdi mdi-arrow-left-bold px-4 py-1"
            ></div>
            <div
              class="v-icon d-flex notranslate mdi mdi-arrow-right-bold px-4 py-1"
            ></div>
          </v-flex>

          <v-flex xs4 class="elevation-1 pa-3 ma-2">
            <v-list style="max-height:500px" class="overflow-y-auto"> <!--v-on:change="subtractTransferedLessons()"-->
              <v-subheader>
                <b>REMAINING LESSON LIST </b>
              </v-subheader>
              <draggable 
                v-model="remainingLessonList" 
                :options="{group:'lessons'}" 
                style="min-height: 10px" 
              >
              <!-- v-on:change="subtractTransferedLessons()"> -->
                <template v-for="item in remainingLessonList"  >
                  <v-list-item :key="item._id" >
                    <v-list-item-content>
                      <v-list-item-title 
                        v-html="item.lessonId" 
                      ></v-list-item-title>
                      <v-list-item-subtitle 
                        v-html="item.lessonTitle" 
                       ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </draggable>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

    <v-divider></v-divider>
      <v-row>
        <v-col cols="10">
          <v-card-actions style="justify-content:center;">
            <v-btn class="mx-5" text @click="$router.go(-1)"
            >cancel</v-btn>
            <v-btn
              class="mx-5"
              :disabled="disabled"
              type="submit"
              color="secondary"
              width="90"
              @click="saveLessonsToCourse"
            >Save</v-btn
            >
          </v-card-actions>
        </v-col>
      </v-row>
         
      <v-row v-if="errorMessage || successMessage">
        <v-col cols="6" offset-md="2">
          <v-alert v-if="errorMessage" type="error">
            {{errorMessage}}
          </v-alert>
          <v-alert v-if="successMessage" type="success">
            {{successMessage}}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import CourseLessonMapping from "../../models/CourseLessonMapping";
import draggable from 'vuedraggable'
import Vue from 'vue'
Vue.component('draggable', draggable)

export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) 
                   {
                     vm.$router.push("/");
                   }
                   
            }, 0);
        });
    },
    name: "ModifyLessonsInACourse",
    components: {
            draggable
        },
    data() {
        return {
          search1:'', 
          search2:'',
          successMessage:'',
          errorMessage:'',
          disabled:false,
          courseLessonList:[],
          remainingLessonList:[], 
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        },
    },

    methods:
    {
      getExistingLessonsOfACourse(){
        //console.log('get lessons in a course', this.course_id);
          CourseLessonMapping.getExistingLessonsOfACourse(this.course_id, this.auth.token)
          .then(res=>{
            //console.log('existing lessons', res);
            this.courseLessonList=res.data;
          }) .catch(err => {
            this.errorMessage = err.response.data;
            setTimeout(() => (this.errorMessage = ""), 5000);
            this.disabled = false;
          });
        },

        getRemainingLessonsOfACourse(){
          CourseLessonMapping.getRemainingLessonsOfACourse(this.course_id, this.auth.token)
          .then(res=>{
            //console.log('remaining lessons', res);
            this.remainingLessonList=res.data;
          }) 
          .catch(err => {
            this.errorMessage = err.response.data;
            setTimeout(() => (this.errorMessage = ""), 5000);
            this.disabled = false;
          });
        },

        saveLessonsToCourse() {
          this.disabled = true;
          //console.log('save lessons to course');
          CourseLessonMapping.putLessonsToCourse( this.course_id, this.courseLessonList,  this.auth.token)
          .then(res => {
            this.disabled = false;
            console.log('res', res);
            this.successMessage = 'Lessons added successfully';
            setTimeout(() => (this.successMessage = ""), 5000);
          })
            .catch(err => {
              this.errorMessage = err.response.data;
              setTimeout(() => (this.errorMessage = ""), 5000);
              this.disabled = false;
          });
        },
    },

    mounted(){
      this.course_id=this.$store.state.course._id;
      this.getExistingLessonsOfACourse();
      this.getRemainingLessonsOfACourse()
    }
}
</script>

<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
.mdi {
    color: #1b73ba;
}
</style>